import { defineComponent as _defineComponent } from 'vue'

import FeedBackMessage from "@/components/content/FeedBackMessage.vue"
import SectionCard from "@/views/missions/details/SectionCard.vue"
import { MissionLifecycleBasicFragmentFragment } from "@/gql"
import useRouter from "@/router/useRouter"
import Icon from "@/components/widgets/icons/Icon.vue"
import ActivityItemContent from "@/components/widgets/timeline/ActivityItemContent.vue"
import { useCountry } from "@/hooks/useCountry"
import ExpandableHtmlBlock from "@/components/widgets/common/ExpandableHtmlBlock.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MissionUpdates',
  props: {
    missions: null,
    loading: { type: Boolean },
    route: { default: "missions" }
  },
  setup(__props: any) {

const { router } = useRouter()


const navigateToMissionDetail = (mission: MissionLifecycleBasicFragmentFragment) => {
  router.push(`/missions/${mission.id.toString()}`)
}

const { getCountryByCode } = useCountry()

const missionCompletionDetails = (completion: number) => {
  const states = {
    initial: { text: "Not started", color: "grey" },
    inprogress: { text: "Ongoing", color: "#DFAB46" },
    completed: { text: "Completed", color: "green" },
  }

  if (completion === 0) {
    return states.initial
  } else if (completion > 0 && completion < 100) {
    return states.inprogress
  } else if (completion === 100) {
    return states.completed
  }

  return null
}

const getTags = (mission: MissionLifecycleBasicFragmentFragment) => {
  const tags: Record<string, string> = {
    country: mission.projectLocationCountryCode
      ? getCountryByCode(mission.projectLocationCountryCode)?.en ?? ""
      : "",
    locationType: mission.projectLocationType?.replace(/_/g, " ") ?? "",
    practiceGroup: mission.scopeService?.serviceGroup.name ?? "",
    state: mission.state ?? "",
  }

  return Object.fromEntries(Object.entries(tags).filter(([, value]) => value !== ""))
}

return { __sfc: true,router, navigateToMissionDetail, getCountryByCode, missionCompletionDetails, getTags, FeedBackMessage, SectionCard, Icon, ActivityItemContent, ExpandableHtmlBlock }
}

})